import { UserSubscriptionAction } from "common/types";

import { useCurrentDialog } from "client/common/hooks/stackables";
import ConfirmationDialog from "client/common/components/content/ConfirmationDialog";

import { useUpdateSubscriptionMutation } from "../../hooks";
import { ClientSubscription, ListSubscription } from "../../types";

export type SubscriptionCancelDialogProps = {
  subscription: ClientSubscription | ListSubscription;
};

const SubscriptionCancelDialog = ({ subscription }: SubscriptionCancelDialogProps) => {
  const { close } = useCurrentDialog();
  const {
    mutate: updateSubscription,
    isLoading,
    error,
  } = useUpdateSubscriptionMutation(subscription.id, {
    onSuccess: close,
  });

  return (
    <ConfirmationDialog
      title="Confirm canceling autoship"
      description="By canceling this autoship, you will no longer receive deliveries of this item. This action cannot be undone."
      denyText="No, continue shipments"
      confirmText="Yes, cancel autoship"
      onConfirm={() => updateSubscription({ action: UserSubscriptionAction.Cancel })}
      onDeny={close}
      isLoading={isLoading}
      error={error}
    />
  );
};

export default SubscriptionCancelDialog;
